import { catalog, urlParams } from '../base/store'
import { _app } from '../base/utils'
import { commonComponents } from '../base'

import Catalog from './Catalog.svelte'
import Filters from './Filters.svelte'

const init = async () => {
  urlParams.setParams()
  await urlParams.applyFilters({ pushState: false })
}

init()

window.onpopstate = async () => {
  const endPoint = window.location.pathname.replace('/catalog/', '')
  urlParams.setParams()
  let params = urlParams.getData()
  await catalog.loadData({ endPoint, params })
  // const { price_range: range } = params
  // Object.values(rangeSliders).forEach(x => x.set({ range }))
}

const components = [
  ...commonComponents,
  [Filters, "node-filters"],
  [Catalog, "node-catalog"],
]

export default catalogApp = _app(components)
